import React from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Common from "../../../layouts/Common";
import ResponsiveGallery from "react-responsive-gallery";
import pag from "../../../assets/images/pag.jpg";





const ProthomaloAppsCompetition = () => {
  return (
    <Common>
      <section className="sub-page-banner newsr-bg">
        <Container>
          <Row>
            <Col md={12} className="text-center sup-page-inner">
              <h2>Media section</h2>
              <Breadcrumb className="text-center custom-breadcrumb">
                <Breadcrumb.Item>Home</Breadcrumb.Item>
                <Breadcrumb.Item>Media section</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
          </Row>
        </Container>
      </section>
      <Container>
        <Row className="text-start mt-3">
          <Col md={12}>
            <section className="work-process mt-5">
              <h4 data-aos="flip-up">
              ইএটিএল-প্রথম আলো অ্যাপস প্রতিযোগিতা ২০১৪, হয়ে গেল দিনব্যাপী ‘গ্রুমিং সেশন’
              </h4>
              <label className="text-gray mb-2 w-100">
              Dated : 19 February, 2014
              </label>
            </section>
          </Col>
        </Row>
        <Col md={12} className="mb-5 border-topn pt-3 media-galery">
          <ResponsiveGallery
            useLightBox
            images={[
              {
                src: `${pag}`,
                alt: "med",
                orderS: 1,
                orderM: 1,
                orderL: 1,
                title:
                "ইএটিএল-প্রথম আলো অ্যাপস প্রতিযোগিতা ২০১৪, হয়ে গেল দিনব্যাপী ‘গ্রুমিং সেশন’",
              },
         
              
           
             
              
            ]}
          />
        </Col>
      </Container>
    </Common>
  );
};

export default ProthomaloAppsCompetition;
